module.exports = __webpack_public_path__ + "static/media/gonglve.1374f0e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gonglve.jpg
// module id = 335
// module chunks = 6